import { render } from "./LastAssets.vue?vue&type=template&id=a451eaa4&scoped=true"
import script from "./LastAssets.vue?vue&type=script&lang=js"
export * from "./LastAssets.vue?vue&type=script&lang=js"

import "./LastAssets.vue?vue&type=style&index=0&id=a451eaa4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a451eaa4"]])

export default __exports__